"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessionStorage = useSessionStorage;
const react_1 = require("react");
function useSessionStorage(key, defaultValue) {
    let hasSessionStorage = false;
    try {
        hasSessionStorage = !!window.sessionStorage;
    }
    catch (e) {
        // Catch errors if browser storage access is denied
    }
    const [state, setState] = (0, react_1.useState)(() => {
        if (!hasSessionStorage) {
            return defaultValue;
        }
        const parsed = getParsedStorage(key);
        if (parsed) {
            return parsed;
        }
        sessionStorage.setItem(key, JSON.stringify(defaultValue));
        return defaultValue;
    });
    const setAndSave = (0, react_1.useCallback)((value) => {
        if (hasSessionStorage && value) {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
        setState(value);
    }, [hasSessionStorage, key]);
    return [state, setAndSave];
}
function getParsedStorage(key) {
    try {
        const storedString = sessionStorage.getItem(key);
        return storedString && JSON.parse(storedString);
    }
    catch (e) {
        sessionStorage.removeItem(key);
    }
}
